import React from 'react';
import JsonView from '@uiw/react-json-view';
export const DisplayJson = ({
  value
}) => {
  return /*#__PURE__*/React.createElement(JsonView, {
    value: JSON.parse(value)
  });
};